export const scrollToOffer = (e?: React.MouseEvent) => {
  if (e) {
    e.preventDefault()
  }
  const offerSection = document.getElementById('oferta')
  if (offerSection) {
    offerSection.scrollIntoView({ behavior: 'smooth' })
  }
}
